import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { l } from '@manychat/manyui'

import { AiAutomationContextType, KnowledgeEntry } from 'shared/api/requests/aiAutomation/schemas'

export const KNOWLEDGE_MAX_SIZE = 40000
export const WARNING_SYMBOLS_THRESHOLD = 100
export const MAX_KNOWLEDGE_ENTRIES = 10

export const newKnowledgeEntry: KnowledgeEntry = {
  type: AiAutomationContextType.TEXT,
  content: '',
}

export const knowledgeEntryResolver = (otherEntriesSize: number) =>
  zodResolver(
    z.object({
      type: z.nativeEnum(AiAutomationContextType),
      content: z
        .string()
        .trim()
        .min(5, l.translate('Provide more knowledge to continue'))
        .refine(
          (entryContent) => otherEntriesSize + entryContent.length <= KNOWLEDGE_MAX_SIZE,
          (entryContent) => ({
            message: l.translate(
              `You’ve exceeded the limit — remove {count, plural, one {# character} other {# characters}}`,
              {
                count: otherEntriesSize + entryContent.length - KNOWLEDGE_MAX_SIZE,
              },
            ),
          }),
        ),
    }),
  )
